import { RavelElement } from '../../../base/ravel-element/src/RavelElement.js';
import globalStyles from '../../../../common/global-styles.js';

export class RavelTallyGrid extends RavelElement {
    static get localStyles() {
        return `
        <style>
        :host {
            display: block;
            width: 100%;
            height: 100%;
        }
        #container {
            display: grid;
            width: 100%;
            height: 100%;
        }
        .cell {
            background: #eeeeee;
            border: 1px solid #ffffff;
            aspect-ratio: 1 / 1;
            cursor: pointer;
            transition: background 0.2s;
        }
        .cell.active {
            background: black;
        }
        .cell.extra {
            background: none;
            border: 1px solid none;
            pointer-events: none;
        }
        </style>
        `;
    }
  
    static get html() { 
        return `
        <div id="container">
        </div>
        `;
    }
 
    static get observedAttributes() { 
        return [...super.baseObservedAttributes, 'color', 'cells'];
    }

    constructor() {
        super();
        const template = document.createElement('template');
        template.innerHTML = globalStyles
            + this.constructor.localStyles
            + this.constructor.html;
        this.attachShadow({ mode: 'open' });
        this.shadowRoot.appendChild(template.content.cloneNode(true));
        this.initialize();
    }
  
    connectedCallback() {
        this.setup();
    }
    
    disconnectedCallback() {
        this.teardown();
    }
    
    initialize() {
        this.container = this.shadowRoot.querySelector('#touch-pad-container');
        this.handle = this.shadowRoot.querySelector('#touch-handle');
        this.cells = 14; 
        this.interactive = false;
        this.filled = false;
    }
  
    setup = () => {
        this.observedMessages = [`${this.id}`];
        this.subscribe(this.observedMessages);   
        this.size = Math.ceil(Math.sqrt(this.cells)); 
        this.container = this.shadowRoot.querySelector('#container');
        this.container.style.gridTemplateColumns = `repeat(${this.size}, 1fr)`;
        this.container.style.gridTemplateRows = `repeat(${this.size}, 1fr)`;
        this.addEventListener(`${this.id}`, this.handleEvent);
        for (let i = 0; i < this.size * this.size; i++) {
            const cell = document.createElement('div');
            cell.className = 'cell';
            cell.id = `cell-${i}`;
            if (i >= this.cells) {
                cell.classList.add('extra');
            }
            this.container.appendChild(cell);
        }
    }

    returnEmoji = (evt) => {
        
    }
    
    handleEvent = (evt) => {
        if (evt.detail.cmd === 'activate') {
            if (this.shadowRoot.querySelector(`#cell-${evt.detail.content}`)) {
                this.shadowRoot.querySelector(`#cell-${evt.detail.content}`).classList.add('active');
            }
        }
    }

    teardown = () => {
        this.unsubscribe(this.observedMessages);
    }

    attributeChangedCallback(name, oldValue, newValue) {
        // Call the parent's attributeChangedCallback to preserve its behavior
        super.attributeChangedCallback(name, oldValue, newValue);
        if (name === 'cells') {
            this.cells = parseInt(newValue, 10);
        }
        if (name === 'color') {
            this.color = newValue;
        }
    }
}